import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageSubCategory } from "../../../components/MasterSettings/SubCategory/ManageSubCategory";
export const SubCategoryManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageSubCategory />
        </div>
      </div>
    </div>
  );
};